import Logout from 'core/Logout/Logout';
export default Logout;
